import { API } from '@Providers';

interface LoginPayload {
  email: string;
  password: string;
}

export default async function(payload: LoginPayload) {
    const endpoint = '/api/login';
  
    return API({ endpoint, method: 'post', payload });
};
